module.exports = __webpack_public_path__ + "static/media/livestream.6e370a7d.svg";